export default "__VITE_ASSET__DvxKy$UE__"